"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PapyrusPolling = exports.PapyrusPollingStatus = void 0;
var PapyrusPollingStatus;
(function (PapyrusPollingStatus) {
    PapyrusPollingStatus["Wait"] = "WAIT";
    PapyrusPollingStatus["Processing"] = "PROCESSING";
    PapyrusPollingStatus["Ready"] = "READY";
    PapyrusPollingStatus["Done"] = "DONE";
    PapyrusPollingStatus["Failed"] = "FAILED";
})(PapyrusPollingStatus = exports.PapyrusPollingStatus || (exports.PapyrusPollingStatus = {}));
class PapyrusPolling {
}
exports.PapyrusPolling = PapyrusPolling;
//# sourceMappingURL=papyrus.js.map